import React, { useEffect } from 'react'
import { useState } from 'react';
import axios from 'axios';
import { Input } from 'reactstrap'
import SuccessPopups from '../../../../components/Popups/SuccessPopups';
import { environment } from '../../../../env';
import EmptyTable from '../../../../components/errorComponents/EmptyTable';
import { MagnifyingGlass, Trash } from '@phosphor-icons/react';
import CustomBillModal from '../../../../components/Modal/CustomBillModal';
import { useDispatch, useSelector } from 'react-redux';
import { loaderAction } from '../../../../redux/actions/Index';
import Table from '../../../../components/Table';
import moment from 'moment';
import PriceFormater from '../../../../Helper/PriceFormater';
import PathName from '../../../../components/PathName/PathName';

const CustomBill = () => {
    const gsts = useSelector((state) => state?.ModalReducer?.dgst)

    const [customBill, setCustomBill] = useState()

    const dispatch = useDispatch();

    const getCustomBill = () => {
        dispatch(loaderAction())
        try {
            axios.get(`${environment.baseUrl}custom-bill`).then((res) => {
                setCustomBill(res.data);
                dispatch(loaderAction())
            }).catch(res => {
                dispatch(loaderAction())
                console.log("error");
            })
        } catch (err) {
            dispatch(loaderAction());
            console.log(err);
        };
    }
    const columns = [
        {
            name: 'Create Date',
            selector: row => moment(row.date).format('DD/MM/YYYY'),
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Tenant Name',
            selector: row => row.tenant_name,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Address',
            selector: row => row.tenant_address,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Description',
            selector: row => row.description,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'HSN/SAC',
            selector: row => row.hsn,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Quantity',
            selector: row => row.quantity,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Rate',
            selector: row => row.rate,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Unit',
            selector: row => row.unit,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Amount',
            selector: row => <PriceFormater price={Number(row.quantity * row.rate)} />,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Total',
            selector: row => <PriceFormater price={Number(row.quantity * row.rate) + Number((row.quantity * row.rate) * (gsts / 100) + Number((row.quantity * row.rate) * (gsts / 100)))} />,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },

    ];
    useEffect(() => {
        getCustomBill()
    }, [])

    return (
        <>
            <PathName />
            <SuccessPopups />
            <div className="City-main">
                <div className='my-3 pb-1'>
                    <div className='d-flex align-items-center bg-white px-4 border-radius-10'>
                        <MagnifyingGlass size={30} />
                        <Input
                            className='p-4 border-0 shadow-none   w-100 fs-3 title-font-500 fs-2 '
                            type='text'
                            autoComplete='off'
                            placeholder='Search...'
                        />
                    </div>
                    <br />
                </div>
                <div className="bg-white rounded-5 mb-5 shadow-sm  p-4 p-md-4 p-lg-5 p-xl-5">
                    <div >
                        <div className='d-flex justify-content-between align-items-center'>
                            <span>
                                <h1 className='title-font-bold '>Custom Bill</h1>
                            </span>
                            <CustomBillModal getCustomBill={getCustomBill} />
                        </div>
                        {
                            customBill?.length > 0 ? <Table data={customBill} columns={columns} /> :
                                <EmptyTable />

                        }
                    </div>
                </div>
                <div className="d-flex gap-5">
                </div>
            </div>
        </>
    )
}

export default CustomBill